import React from "react";
import { Phone, Mail, MapPin, MessageCircle, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  PHONE,
  PHONE_ALT,
  EMAIL,
  WHATSAPP_LINK,
  LOCATION,
  MAPS_LINK,
} from "@/lib/constants";

export default function Contact() {
  return (
    <section
      id="contacto"
      data-testid="contact-section"
      className="relative py-24 lg:py-32 bg-[#12141a] border-y border-white/5 overflow-hidden"
    >
      <div className="absolute -right-32 top-1/3 w-96 h-96 bg-[#ff6b00]/20 blur-[140px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#ff6b00] mb-4 flex items-center gap-3">
              <span className="w-8 h-px bg-[#ff6b00]" />
              <span>Contacto directo</span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter mb-6">
              ¿Necesitas ayuda con tu transformador?
            </h2>
            <p className="text-[#a0aabf] leading-relaxed text-lg mb-8 max-w-lg">
              Atendemos emergencias 24/7 en Bucaramanga y toda Santander.
              Habla directamente con un técnico calificado.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noreferrer"
                data-testid="contact-cta-whatsapp"
              >
                <Button className="w-full sm:w-auto bg-[#25D366] hover:bg-[#1eb854] text-white font-bold uppercase tracking-wider text-sm rounded-none h-14 px-8">
                  <MessageCircle className="w-4 h-4 mr-2" />
                  Chatear por WhatsApp
                </Button>
              </a>
              <a href="#cotizador" data-testid="contact-cta-quote">
                <Button
                  variant="outline"
                  className="w-full sm:w-auto border-white/20 hover:border-white text-white hover:bg-white/5 bg-transparent font-bold uppercase tracking-wider text-sm rounded-none h-14 px-8"
                >
                  Solicitar cotización
                </Button>
              </a>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="grid sm:grid-cols-2 gap-px bg-white/5 border border-white/5">
              {[
                {
                  icon: Phone,
                  label: "Teléfono principal",
                  value: PHONE,
                  href: `tel:${PHONE.replace(/\s/g, "")}`,
                  test: "contact-phone",
                },
                {
                  icon: Phone,
                  label: "Teléfono alterno",
                  value: PHONE_ALT,
                  href: `tel:${PHONE_ALT.replace(/\s/g, "")}`,
                  test: "contact-phone-alt",
                },
                {
                  icon: Mail,
                  label: "Correo electrónico",
                  value: EMAIL,
                  href: `mailto:${EMAIL}`,
                  test: "contact-email",
                  long: true,
                },
                {
                  icon: MapPin,
                  label: "Sede principal",
                  value: LOCATION,
                  href: MAPS_LINK,
                  external: true,
                  test: "contact-location",
                },
                {
                  icon: Clock,
                  label: "Horario",
                  value: "Lun-Sáb 7:00am - 6:00pm",
                  test: "contact-hours",
                },
                {
                  icon: MessageCircle,
                  label: "Emergencias",
                  value: "24 / 7",
                  test: "contact-emergency",
                },
              ].map((c) => {
                const Tag = c.href ? "a" : "div";
                return (
                  <Tag
                    key={c.label}
                    {...(c.href ? { href: c.href } : {})}
                    {...(c.external ? { target: "_blank", rel: "noreferrer" } : {})}
                    data-testid={c.test}
                    className="bg-[#0a0a0a] p-6 hover:bg-[#1a1d24] transition-colors block"
                  >
                    <c.icon className="w-5 h-5 text-[#ff6b00] mb-4" strokeWidth={1.5} />
                    <div className="text-[10px] uppercase tracking-[0.3em] text-[#a0aabf] mb-2">
                      {c.label}
                    </div>
                    <div className={`font-display font-semibold ${c.long ? "text-sm break-words" : "text-base"}`}>
                      {c.long ? c.value.replace("@", "@​") : c.value}
                    </div>
                  </Tag>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
